import { z } from 'zod';

export enum DeliveryMethod {
  Email = 'email',
  SMS = 'sms',
}

export const AuthenticationStartRequestSchema = z.object({
  mode: z.nativeEnum(DeliveryMethod),
  username: z.string(),
});
export type AuthenticationStartRequest = z.infer<
  typeof AuthenticationStartRequestSchema
>;

export const AuthenticationStartResponseSchema = z.object({
  username: z.string(),
  field: z.string(),
});
export type AuthenticationStartResponse = z.infer<
  typeof AuthenticationStartResponseSchema
>;

export const AuthenticationCompleteRequestSchema = z.object({
  mode: z.nativeEnum(DeliveryMethod),
  username: z.string(),
  code: z.string().length(6),
});
export type AuthenticationCompleteRequest = z.infer<
  typeof AuthenticationCompleteRequestSchema
>;

export const AuthenticationCompleteResponseSchema = z.object({
  accessToken: z.string(),
  idToken: z.string(),
  refreshToken: z.string(),
});
export type AuthenticationCompleteResponse = z.infer<
  typeof AuthenticationCompleteResponseSchema
>;
